import { z } from "zod";

export const zLocationParameter = {
  addressLine1: z.string().max(80),
  addressLine2: z.string().max(80).optional(),
  zip: z.string().max(15).optional(),
  city: z.string().max(50),
  cityCode: z.string().max(6).optional(),
  country: z.string().max(50),
  countryCode: z.string().max(3),
};
